import React, { useState } from 'react';
import '../styles/Feedback.css';

const Feedback = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create mailto link with form data
    const mailtoLink = `mailto:subhrajit.pramanick@themotoguru.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(`Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`)}`;

    // Open default email client
    window.location.href = mailtoLink;

    // Clear form and show success message
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: '',
    });
    setStatus('Thank you for your feedback!');

    // Clear success message after 3 seconds
    setTimeout(() => {
      setStatus('');
    }, 3000);
  };

  return (
    <div className='feedback-page'>
      <div className='overlay'></div>
      <div className='feedback-container'>
        <header className='feedback-header'>
          <h1>
            Send us your <span className='accent'>Feedback</span>
          </h1>
          <p className='tagline'>Help us improve MotoGuru AI with your valuable feedback</p>
        </header>

        <div className='feedback-content'>
          <form onSubmit={handleSubmit} className='feedback-form'>
            <div className='form-group'>
              <label htmlFor='name'>Name</label>
              <input type='text' id='name' name='name' value={formData.name} onChange={handleChange} required placeholder='Enter your name' />
            </div>

            <div className='form-group'>
              <label htmlFor='email'>Email</label>
              <input type='email' id='email' name='email' value={formData.email} onChange={handleChange} required placeholder='Enter your email' />
            </div>

            <div className='form-group'>
              <label htmlFor='subject'>Subject</label>
              <input type='text' id='subject' name='subject' value={formData.subject} onChange={handleChange} required placeholder='Enter subject' />
            </div>

            <div className='form-group'>
              <label htmlFor='message'>Message</label>
              <textarea id='message' name='message' value={formData.message} onChange={handleChange} required placeholder='Enter your feedback' rows='6'></textarea>
            </div>

            <button type='submit' className='btn btn-primary'>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'>
                <path d='M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z' />
              </svg>
              Send Feedback
            </button>

            {status && <div className='success-message'>{status}</div>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
